import { Colors } from '@/components/common';

const studentBookStatus = {
  PendientePedido: 1,
  PedienteDeterminacionCSEE: 2,
  PendienteCompra: 3,
  PendienteEntregaCSEE: 4,
  PendienteEntregaEscuela: 5,
  PendienteEntregaEstudiante: 6,
  Entregado: 7,
  Procesado: 8,
  PedienteDeterminacionSAEE: 9,
  NoAprobado: 10,
  PendienteEntregaMaestro:11,
};

const studentBookStatusString = {
  PendientePedido: 'Pendiente de Pedido',
  PedienteDeterminacionCSEE: 'Pendiente de Determinación CSEE',
  PendienteCompra: 'Pendiente de Compra',
  PendienteEntregaCSEE: 'Pendiente de Entrega CSEE',
  PendienteEntregaEscuela: 'Pendiente de Entrega Escuela',
  PendienteEntregaEstudiante: 'Pendiente Entrega Estudiante',
  Entregado: 'Entregado',
  Procesado: 'Procesado',
  PedienteDeterminacionSAEE: 'Pendiente de Determinación SAEE',
  NoAprobado: 'No Aprobado',
  PendienteEntregaMaestro:'Pendiente de Entrega Maestro',
};

const getStudentBookStatusColor = (statusId, isHexColor) => {
  switch (statusId) {
    case studentBookStatus.Procesado:
      return isHexColor ? '#fce0c8' : Colors.PEACH;
    case studentBookStatus.Entregado:
      return isHexColor ? '#a3e5b3' : Colors.GREEN_LIGHT;
    case studentBookStatus.PedienteDeterminacionCSEE:
    case studentBookStatus.PedienteDeterminacionSAEE:
    case studentBookStatus.PendientePedido:
    case studentBookStatus.PendienteCompra:
      return isHexColor ? '#f8ea80' : Colors.YELLOW;
    case studentBookStatus.PendienteEntregaCSEE:
    case studentBookStatus.PendienteEntregaEscuela:
    case studentBookStatus.PendienteEntregaEstudiante:
      return isHexColor ? '#fcc9c8' : Colors.PINK;
    default:
      return isHexColor ? '#f8ea80' : Colors.YELLOW;
  }
};

export {
  studentBookStatus,
  studentBookStatusString,
  getStudentBookStatusColor,
};
